export default "__VITE_ASSET__DTBfg_QY__"